var _circle, _path, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossIconRoundRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#F64040"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3732 4.02815C8.75574 4.17195 7.2322 4.89055 6.06074 6.06213C3.31309 8.81014 3.31309 13.191 6.06074 15.939C8.80839 18.687 13.1887 18.687 15.9363 15.939C17.1253 14.7499 17.8269 13.2462 17.9724 11.575C18.0171 11.0626 18.0101 10.9213 17.9324 10.7666C17.8483 10.5989 17.7144 10.5042 17.5377 10.4872C17.3013 10.4645 17.0766 10.5852 16.9959 10.7784C16.9721 10.8355 16.9466 11.0428 16.932 11.2994C16.8825 12.167 16.7105 12.8305 16.3324 13.6129C15.5973 15.1338 14.1121 16.3474 12.4837 16.7576C11.9021 16.9041 11.7403 16.922 10.9985 16.922C10.2567 16.922 10.0949 16.9041 9.51336 16.7576C7.47267 16.2436 5.75619 14.5269 5.24221 12.4859C5.09575 11.9043 5.07784 11.7425 5.07784 11.0006C5.07784 10.2587 5.09575 10.0968 5.24221 9.5152C5.65234 7.88664 6.86578 6.40119 8.38653 5.66602C9.16887 5.28782 9.83224 5.11584 10.6998 5.06636C10.9563 5.05169 11.1636 5.02625 11.2207 5.00237C11.4138 4.92168 11.5345 4.69699 11.5118 4.46054C11.4948 4.28378 11.4001 4.14993 11.2325 4.06579C11.0832 3.99081 10.8889 3.98231 10.3732 4.02815Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.45906,
    y1: 8.28027,
    x2: 13.173,
    y2: 13.9942,
    stroke: "white",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7.82129,
    y1: 13.995,
    x2: 13.5352,
    y2: 8.28113,
    stroke: "white",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIconRoundRed);
export default __webpack_public_path__ + "static/media/crossIconRoundRed.1d538a3578d3b30784da72d43bc5dc84.svg";
export { ForwardRef as ReactComponent };